export default "__VITE_ASSET__b8ca6d25__"